
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35040',
  depVersions: {
  "documents-public-ui": "static-1.35040",
  "atom": "static-1.5286",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2707",
  "client-types": "static-1.489",
  "cssUtils": "static-1.855",
  "customer-data-filters-ui": "static-1.40594",
  "customer-data-objects": "static-1.7893",
  "customer-data-property-utils": "static-1.8305",
  "documents-lib": "static-1.35045",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.355",
  "FormsCommonComponents": "static-1.86400",
  "FormUrlGenerator": "static-2.4933",
  "foundations-theming-specialty": "static-1.2371",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5803",
  "hs-test-utils": "static-1.8235",
  "hub-http": "static-1.6427",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11991",
  "HubStyleTokens": "static-2.11684",
  "I18n": "static-7.1651",
  "icons": "static-2.668",
  "jasmine-immutable": "static-1.3231",
  "jasmine-runner": "static-1.6664",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7361",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3107",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5605",
  "quartz": "static-1.7312",
  "react": "static-7.189",
  "react-dlb": "static-1.83",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16913",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5487",
  "react-virtualized": "static-2.102",
  "reference-resolvers": "static-1.8388",
  "reference-resolvers-lite": "static-1.8305",
  "reporting-data": "static-1.68402",
  "reporting-reports": "static-1.68080",
  "reporting-snowflake": "static-1.57020",
  "reporting-testing-lib": "static-1.10335",
  "reporting-visualizations": "static-1.60478",
  "reselect": "static-3.8",
  "sales-content-partitioning": "static-1.9158",
  "sanitize": "static-1.4687",
  "sanitize-text": "static-1.8357",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1954",
  "signup-constants": "static-1.19397",
  "signup-ui-url-generator": "static-2.8267",
  "StyleGuideUI": "static-3.491",
  "superstore": "static-1.4968",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4964",
  "ui-addon-form-validation": "static-1.11197",
  "ui-asset-management-lib": "static-1.11297",
  "ui-images": "static-2.1215",
  "UIComponents": "static-3.8630",
  "usage-tracker": "static-1.7562",
  "usage-tracker-container": "static-1.7552",
  "usage-tracker-core": "static-1.7412",
  "viral-links-lib": "static-1.7280",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9867",
  "foundations-components": "static-1.8320",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1090",
  "quartz-core": "static-1.6531",
  "quick-fetch": "static-1.4063",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4869",
  "ui-addon-i18n": "static-1.11357",
  "ui-addon-upgrades": "static-9.18272",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3545",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3589",
  "quartz-webpack": "static-1.3536",
  "foundations-assets": "static-1.5085",
  "foundations-theming": "static-1.4655",
  "hub-http-shared-msw-handlers": "static-1.10460",
  "hubspotter-http": "static-1.4797",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7457",
  "crm-message-bus": "static-1.43563",
  "customer-data-filters-ui-msw-helpers": "static-1.23029",
  "customer-data-objects-ui-components": "static-1.13240",
  "customer-data-reference-ui-components": "static-1.13386",
  "customer-data-ui-utilities": "static-1.10034",
  "events-data-lib": "static-1.448",
  "framework-builder-read-service-client": "static-1.4152",
  "framework-data-schema-quick-fetch": "static-1.7009",
  "framework-data-schema-resolvers": "static-1.7104",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.3991",
  "multi-account-reference-resolvers": "static-1.1194",
  "onboarding-tours": "static-1.16981",
  "reporting-datasets-permissions-lib": "static-1.14280",
  "stylex": "static-1.37",
  "trellis-assets": "static-1.2361",
  "trellis-components": "static-1.2380",
  "trellis-theming": "static-1.1164",
  "ui-addon-teams": "static-1.21813",
  "quartz-auth": "static-1.987",
  "ui-business-units-lib": "static-1.9290",
  "usage-tracker-session-replay": "static-1.5248",
  "ai-components-ui-library": "static-1.9481",
  "ContentUtils": "static-1.68964",
  "customer-data-properties": "static-1.52303",
  "forms-ai-lib": "static-1.4631",
  "forms-utils-lib": "static-1.12956",
  "foundations-components-test-utils": "static-1.5803",
  "react-dnd-compat": "static-1.4824",
  "react-tinymce": "static-1.55793",
  "tinymce-config": "static-2.54919",
  "ui-gdpr-components": "static-1.10560",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3640",
  "HeadJS": "static-2.782",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3346",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.227",
  "ui-fonts": "static-1.946",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4533",
  "csstype": "static-1.50",
  "quartz-head": "static-1.977",
  "web-vitals": "static-1.9",
  "batch-promise": "static-1.1754",
  "external-options-client-types": "static-1.4272",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.987",
  "frontend-preferences-client": "static-1.8136",
  "graphql": "static-1.85",
  "persist-promise": "static-1.3911",
  "reporting-client-types": "static-1.2633",
  "apollo-stack-hubspot": "static-3.89",
  "growth-payments-core": "static-1.25983",
  "hubspot-apollo-client": "static-1.5087",
  "foundations-components-legacy": "static-1.1345",
  "quartz-routing": "static-1.742",
  "hs-story-utils": "static-1.9635",
  "react-flip-move": "static-1.74",
  "nested-table": "static-1.447",
  "timezone-utils": "static-2.5454",
  "seat-types-lib": "static-1.494",
  "react-create-root-preference": "static-1.51",
  "bend-plugin-foundations-components": "static-1.4589",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.859",
  "mobile-manifest-mixins": "static-1.556",
  "module-federation": "static-1.29",
  "quartz-test": "static-1.987",
  "quartz-tracking": "static-1.691",
  "bend-plugin-chirp-manifest": "static-1.279",
  "chirp-fetch": "static-1.2097",
  "merchandise-lib": "static-1.269",
  "purchase-motions-components": "static-1.6230",
  "salesImages": "static-1.529",
  "ts-schema": "static-1.4226",
  "bender-build-tools": "static-1.3323",
  "bend-plugin-foundations-theming": "static-1.3138",
  "restore-request-side-panel-lib": "static-1.1426",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.390",
  "pulse": "static-1.826",
  "conditional-properties-service-client": "static-1.3943",
  "crm-pipelines-api-client-types": "static-1.4282",
  "fdsr-migration-layer": "static-1.223",
  "multi-currency-client-types": "static-1.3837",
  "getting-started-shared-tasks": "static-1.19015",
  "growth-data-modal": "static-1.5760",
  "growth-onboarding-confetti": "static-1.3270",
  "growth-onboarding-next-action-utils": "static-1.2511",
  "navigation-components": "static-1.18626",
  "onboarding-tours-client": "static-1.5195",
  "onboarding-tours-utils": "static-1.1047",
  "ui-shepherd-react": "static-3.10471",
  "ui-shepherd-tracker": "static-1.7852",
  "ui-universal-auth": "static-1.9229",
  "user-context": "static-1.5321",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.33",
  "hubspotter-http-shared-msw-handlers": "static-1.10458",
  "magpie-lib": "static-1.5699",
  "navigation-messaging": "static-1.7953",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22383",
  "copilot-toolkit": "static-1.11667",
  "cms-field-types": "static-1.5025",
  "content-icons-ui": "static-1.2291",
  "integrations-lib": "static-1.16807",
  "calling-global-api": "static-1.65213",
  "calling-internal-common": "static-1.31524",
  "calling-lifecycle-internal": "static-1.66595",
  "calling-lifecycle-messages": "static-1.58889",
  "commerce-products-lib": "static-1.10300",
  "crm-links": "static-1.6528",
  "crm-index-visualization-core": "static-1.4411",
  "customer-data-properties-shared-msw-handlers": "static-1.9787",
  "file-manager-components": "static-1.24248",
  "formula-editor": "static-1.14616",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4362",
  "meetings-icalendar-utils-lib": "static-1.841",
  "object-builder-ui-client": "static-1.49416",
  "pipeline-validation-client-types": "static-1.4112",
  "property-value-citations": "static-1.2917",
  "smart-property-lib": "static-1.8106",
  "tiered-pricing": "static-1.1792",
  "topics-actions-lib": "static-1.365",
  "ui-addon-iframeable": "static-1.9283",
  "zustand": "static-1.79",
  "final-form": "static-1.73",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20181",
  "tinymce-themes": "static-1.56889",
  "data-token-picker": "static-1.16762",
  "hub-http-contrib": "static-1.3251",
  "interframe": "static-3.4965",
  "tinymce-data": "static-1.41004",
  "tinymce-plugins": "static-1.58033",
  "ui-addon-sales-email": "static-1.5422",
  "onboarding-scopes": "static-1.6668",
  "ui-addon-opt": "static-4.8570",
  "apollo-link-hub-http": "static-2.4865",
  "hubspot-apollo-cache": "static-1.546",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.383",
  "purchase-motions-api": "static-1.6233",
  "event-emitter": "static-1.1160",
  "bend-plugin-pulse": "static-1.329",
  "fast-json-patch": "static-1.66",
  "onboarding-data-sync-lib": "static-1.2325",
  "growth-onboarding-next-action-components": "static-1.2539",
  "user-context-client": "static-1.4754",
  "idb-keyval": "static-1.47",
  "magpie-types": "static-1.5159",
  "nest": "static-1.447",
  "reactive-lib": "static-1.932",
  "simple-logging-lib": "static-1.3259",
  "unified-auth-core-lib": "static-1.1025",
  "getting-started-shared-tasks-store": "static-1.18133",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1455",
  "integrations-error-boundary-lib": "static-1.14222",
  "integrations-tracking-lib": "static-1.5817",
  "native-integrations-shared-strings": "static-1.7986",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10575",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.743",
  "calling-error-reporting": "static-1.31531",
  "shared-worker-versioning": "static-1.11247",
  "calling-usage-tracker": "static-1.6751",
  "voice-sms-access-library": "static-1.1739",
  "customer-data-tracking": "static-1.7094",
  "commerce-permissions": "static-1.986",
  "products-iframe-lib": "static-1.8423",
  "products-ui-components-shared-msw-handlers": "static-1.10842",
  "location-customization-utils-lib": "static-1.9893",
  "crm-index-associations-lib": "static-1.6651",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10543",
  "sales-views-client-types": "static-1.4466",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4358",
  "video-components-external": "static-1.11940",
  "video-data-lib": "static-1.35598",
  "bark-lib": "static-1.16708",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6097",
  "react-codemirror": "static-1.10850",
  "data-agent-kit": "static-1.514",
  "feedback-loader": "static-1.29674",
  "fsm": "static-1.3942",
  "policy-lib": "static-1.6998",
  "react-colorpicker": "static-2.10419",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10606",
  "FileManagerLib": "static-1.39888",
  "NamespacedHubStyle": "static-2.9195",
  "FileManagerCore": "static-1.39747",
  "content-assistance-lib": "static-1.8075",
  "layout-dnd-components": "static-1.12835",
  "layout-dnd-utils": "static-1.11810",
  "ui-addon-emoji-picker": "static-1.10095",
  "ui-brand-identity-lib": "static-1.16054",
  "InboxConnectUtils": "static-4.15372",
  "meetings-connect-utils-lib": "static-1.7816",
  "breeze-engine-chat-components": "static-1.433",
  "breeze-engine-core": "static-1.733",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "universal-page-editor-lib": "static-1.3221",
  "adobe-sign-auth-lib": "static-1.268",
  "ads-unified-auth-lib": "static-1.799",
  "google-sheets-integration-lib": "static-1.843",
  "microsoft-drive-integration-lib": "static-1.966",
  "surveymonkey-integration-lib": "static-1.287",
  "slack-ui-library": "static-1.10609",
  "calling-orchestration-schema": "static-1.36516",
  "crm-record-cards-service-types": "static-1.3730",
  "content-media-composition-data-lib": "static-1.12988",
  "content-media-compositions": "static-2.16995",
  "media-bridge-lib": "static-1.19279",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16179",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4717",
  "storybook-react": "static-1.36",
  "audio-components": "static-1.6219",
  "FileManagerImages": "static-1.37399",
  "video-components": "static-1.13942",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4742",
  "video-embed": "static-1.36432",
  "ui-addon-video-player": "static-1.8916",
  "ui-coaching-tips": "static-1.29134",
  "ContentData": "static-1.69039",
  "layout-data-lib": "static-1.10135",
  "social-insights-client-types": "static-1.22606",
  "outpost": "static-1.4374",
  "growth-onboarding-feedback-components": "static-1.6791",
  "advanced-menus-core": "static-1.15457",
  "advanced-menus-lib": "static-1.12349",
  "ExportDialog": "static-6.10587",
  "ui-memberships-settings-lib": "static-1.34630",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15456",
  "simple-menus-lib": "static-1.16973"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35040",
  "atom": "/atom/static-1.5286",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2707",
  "client-types": "/client-types/static-1.489",
  "cssUtils": "/cssUtils/static-1.855",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40594",
  "customer-data-objects": "/customer-data-objects/static-1.7893",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8305",
  "documents-lib": "/documents-lib/static-1.35045",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.355",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86400",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4933",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2371",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5803",
  "hs-test-utils": "/hs-test-utils/static-1.8235",
  "hub-http": "/hub-http/static-1.6427",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11991",
  "HubStyleTokens": "/HubStyleTokens/static-2.11684",
  "I18n": "/I18n/static-7.1651",
  "icons": "/icons/static-2.668",
  "jasmine-immutable": "/jasmine-immutable/static-1.3231",
  "jasmine-runner": "/jasmine-runner/static-1.6664",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7361",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3107",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5605",
  "quartz": "/quartz/static-1.7312",
  "react": "/react/static-7.189",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16913",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5487",
  "react-virtualized": "/react-virtualized/static-2.102",
  "reference-resolvers": "/reference-resolvers/static-1.8388",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8305",
  "reporting-data": "/reporting-data/static-1.68402",
  "reporting-reports": "/reporting-reports/static-1.68080",
  "reporting-snowflake": "/reporting-snowflake/static-1.57020",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10335",
  "reporting-visualizations": "/reporting-visualizations/static-1.60478",
  "reselect": "/reselect/static-3.8",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9158",
  "sanitize": "/sanitize/static-1.4687",
  "sanitize-text": "/sanitize-text/static-1.8357",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1954",
  "signup-constants": "/signup-constants/static-1.19397",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8267",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "superstore": "/superstore/static-1.4968",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4964",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11197",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11297",
  "ui-images": "/ui-images/static-2.1215",
  "UIComponents": "/UIComponents/static-3.8630",
  "usage-tracker": "/usage-tracker/static-1.7562",
  "usage-tracker-container": "/usage-tracker-container/static-1.7552",
  "usage-tracker-core": "/usage-tracker-core/static-1.7412",
  "viral-links-lib": "/viral-links-lib/static-1.7280",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9867",
  "foundations-components": "/foundations-components/static-1.8320",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1090",
  "quartz-core": "/quartz-core/static-1.6531",
  "quick-fetch": "/quick-fetch/static-1.4063",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4869",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11357",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18272",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3545",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3589",
  "quartz-webpack": "/quartz-webpack/static-1.3536",
  "foundations-assets": "/foundations-assets/static-1.5085",
  "foundations-theming": "/foundations-theming/static-1.4655",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10460",
  "hubspotter-http": "/hubspotter-http/static-1.4797",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7457",
  "crm-message-bus": "/crm-message-bus/static-1.43563",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23029",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13240",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13386",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10034",
  "events-data-lib": "/events-data-lib/static-1.448",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4152",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7009",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7104",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3991",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1194",
  "onboarding-tours": "/onboarding-tours/static-1.16981",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14280",
  "stylex": "/stylex/static-1.37",
  "trellis-assets": "/trellis-assets/static-1.2361",
  "trellis-components": "/trellis-components/static-1.2380",
  "trellis-theming": "/trellis-theming/static-1.1164",
  "ui-addon-teams": "/ui-addon-teams/static-1.21813",
  "quartz-auth": "/quartz-auth/static-1.987",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9290",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5248",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9481",
  "ContentUtils": "/ContentUtils/static-1.68964",
  "customer-data-properties": "/customer-data-properties/static-1.52303",
  "forms-ai-lib": "/forms-ai-lib/static-1.4631",
  "forms-utils-lib": "/forms-utils-lib/static-1.12956",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5803",
  "react-dnd-compat": "/react-dnd-compat/static-1.4824",
  "react-tinymce": "/react-tinymce/static-1.55793",
  "tinymce-config": "/tinymce-config/static-2.54919",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10560",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3640",
  "HeadJS": "/HeadJS/static-2.782",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3346",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.227",
  "ui-fonts": "/ui-fonts/static-1.946",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4533",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.977",
  "web-vitals": "/web-vitals/static-1.9",
  "batch-promise": "/batch-promise/static-1.1754",
  "external-options-client-types": "/external-options-client-types/static-1.4272",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.987",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8136",
  "graphql": "/graphql/static-1.85",
  "persist-promise": "/persist-promise/static-1.3911",
  "reporting-client-types": "/reporting-client-types/static-1.2633",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "growth-payments-core": "/growth-payments-core/static-1.25983",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5087",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1345",
  "quartz-routing": "/quartz-routing/static-1.742",
  "hs-story-utils": "/hs-story-utils/static-1.9635",
  "react-flip-move": "/react-flip-move/static-1.74",
  "nested-table": "/nested-table/static-1.447",
  "timezone-utils": "/timezone-utils/static-2.5454",
  "seat-types-lib": "/seat-types-lib/static-1.494",
  "react-create-root-preference": "/react-create-root-preference/static-1.51",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4589",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.859",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.556",
  "module-federation": "/module-federation/static-1.29",
  "quartz-test": "/quartz-test/static-1.987",
  "quartz-tracking": "/quartz-tracking/static-1.691",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.279",
  "chirp-fetch": "/chirp-fetch/static-1.2097",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "purchase-motions-components": "/purchase-motions-components/static-1.6230",
  "salesImages": "/salesImages/static-1.529",
  "ts-schema": "/ts-schema/static-1.4226",
  "bender-build-tools": "/bender-build-tools/static-1.3323",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3138",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1426",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.390",
  "pulse": "/pulse/static-1.826",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3943",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4282",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.223",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3837",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19015",
  "growth-data-modal": "/growth-data-modal/static-1.5760",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3270",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2511",
  "navigation-components": "/navigation-components/static-1.18626",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5195",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1047",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10471",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7852",
  "ui-universal-auth": "/ui-universal-auth/static-1.9229",
  "user-context": "/user-context/static-1.5321",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10458",
  "magpie-lib": "/magpie-lib/static-1.5699",
  "navigation-messaging": "/navigation-messaging/static-1.7953",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22383",
  "copilot-toolkit": "/copilot-toolkit/static-1.11667",
  "cms-field-types": "/cms-field-types/static-1.5025",
  "content-icons-ui": "/content-icons-ui/static-1.2291",
  "integrations-lib": "/integrations-lib/static-1.16807",
  "calling-global-api": "/calling-global-api/static-1.65213",
  "calling-internal-common": "/calling-internal-common/static-1.31524",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66595",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58889",
  "commerce-products-lib": "/commerce-products-lib/static-1.10300",
  "crm-links": "/crm-links/static-1.6528",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4411",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9787",
  "file-manager-components": "/file-manager-components/static-1.24248",
  "formula-editor": "/formula-editor/static-1.14616",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4362",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.841",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49416",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4112",
  "property-value-citations": "/property-value-citations/static-1.2917",
  "smart-property-lib": "/smart-property-lib/static-1.8106",
  "tiered-pricing": "/tiered-pricing/static-1.1792",
  "topics-actions-lib": "/topics-actions-lib/static-1.365",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9283",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.73",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20181",
  "tinymce-themes": "/tinymce-themes/static-1.56889",
  "data-token-picker": "/data-token-picker/static-1.16762",
  "hub-http-contrib": "/hub-http-contrib/static-1.3251",
  "interframe": "/interframe/static-3.4965",
  "tinymce-data": "/tinymce-data/static-1.41004",
  "tinymce-plugins": "/tinymce-plugins/static-1.58033",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5422",
  "onboarding-scopes": "/onboarding-scopes/static-1.6668",
  "ui-addon-opt": "/ui-addon-opt/static-4.8570",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4865",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.546",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.383",
  "purchase-motions-api": "/purchase-motions-api/static-1.6233",
  "event-emitter": "/event-emitter/static-1.1160",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.329",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2325",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2539",
  "user-context-client": "/user-context-client/static-1.4754",
  "idb-keyval": "/idb-keyval/static-1.47",
  "magpie-types": "/magpie-types/static-1.5159",
  "nest": "/nest/static-1.447",
  "reactive-lib": "/reactive-lib/static-1.932",
  "simple-logging-lib": "/simple-logging-lib/static-1.3259",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1025",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18133",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1455",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14222",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5817",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7986",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10575",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.743",
  "calling-error-reporting": "/calling-error-reporting/static-1.31531",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11247",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6751",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1739",
  "customer-data-tracking": "/customer-data-tracking/static-1.7094",
  "commerce-permissions": "/commerce-permissions/static-1.986",
  "products-iframe-lib": "/products-iframe-lib/static-1.8423",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10842",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9893",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6651",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10543",
  "sales-views-client-types": "/sales-views-client-types/static-1.4466",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4358",
  "video-components-external": "/video-components-external/static-1.11940",
  "video-data-lib": "/video-data-lib/static-1.35598",
  "bark-lib": "/bark-lib/static-1.16708",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6097",
  "react-codemirror": "/react-codemirror/static-1.10850",
  "data-agent-kit": "/data-agent-kit/static-1.514",
  "feedback-loader": "/feedback-loader/static-1.29674",
  "fsm": "/fsm/static-1.3942",
  "policy-lib": "/policy-lib/static-1.6998",
  "react-colorpicker": "/react-colorpicker/static-2.10419",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10606",
  "FileManagerLib": "/FileManagerLib/static-1.39888",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9195",
  "FileManagerCore": "/FileManagerCore/static-1.39747",
  "content-assistance-lib": "/content-assistance-lib/static-1.8075",
  "layout-dnd-components": "/layout-dnd-components/static-1.12835",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11810",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10095",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16054",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15372",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7816",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.433",
  "breeze-engine-core": "/breeze-engine-core/static-1.733",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3221",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.268",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.799",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.843",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.966",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.287",
  "slack-ui-library": "/slack-ui-library/static-1.10609",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36516",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3730",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12988",
  "content-media-compositions": "/content-media-compositions/static-2.16995",
  "media-bridge-lib": "/media-bridge-lib/static-1.19279",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16179",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4717",
  "storybook-react": "/storybook-react/static-1.36",
  "audio-components": "/audio-components/static-1.6219",
  "FileManagerImages": "/FileManagerImages/static-1.37399",
  "video-components": "/video-components/static-1.13942",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4742",
  "video-embed": "/video-embed/static-1.36432",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8916",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29134",
  "ContentData": "/ContentData/static-1.69039",
  "layout-data-lib": "/layout-data-lib/static-1.10135",
  "social-insights-client-types": "/social-insights-client-types/static-1.22606",
  "outpost": "/outpost/static-1.4374",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6791",
  "advanced-menus-core": "/advanced-menus-core/static-1.15457",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12349",
  "ExportDialog": "/ExportDialog/static-6.10587",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34630",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15456",
  "simple-menus-lib": "/simple-menus-lib/static-1.16973"
}
};
